import { render, staticRenderFns } from "./UpsellTree.vue?vue&type=template&id=2bc64ece&scoped=true&"
import script from "./UpsellTree.vue?vue&type=script&lang=js&"
export * from "./UpsellTree.vue?vue&type=script&lang=js&"
import style0 from "./UpsellTree.vue?vue&type=style&index=0&id=2bc64ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc64ece",
  null
  
)

export default component.exports